(function(){
'use strict';
if(!window.I5G||window.__i5gInit)return;window.__i5gInit=1;
var base=window.I5G.base,projs=window.I5G.p;
var IG='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="flex:none"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="1.2" fill="currentColor" stroke="none"/></svg>';
function url(name,w){if(!name)return '';var u=base+name;return w?u+'?width='+w:u;}
function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function first(name){return (name||'').split(/[+&,]/)[0].trim();}
var cfg=document.querySelector('[data-i5book]');
var BOOK=(cfg&&cfg.getAttribute('data-i5book'))||'/products/interior-consultation-service';
var DZL=(cfg&&cfg.getAttribute('data-i5dz'))||'Designed by';
var BKL=(cfg&&cfg.getAttribute('data-i5bl'))||'Book a free consultation with';
var lb=document.createElement('div');lb.className='i5glb';
lb.innerHTML='<div class="i5glb-bar"><div class="i5glb-t"><b></b><span></span></div><div class="i5glb-meta i5glb-meta-d"></div><button class="i5glb-x" aria-label="Close">×</button></div>'+
'<div class="i5glb-body"><div class="i5glb-meta i5glb-meta-m"></div><div class="i5glb-stage"><button class="i5glb-nav i5glb-prev" aria-label="Previous">‹</button><img class="i5glb-img" alt="" decoding="async"><button class="i5glb-nav i5glb-next" aria-label="Next">›</button></div><div class="i5glb-thumbs"></div><div class="i5glb-foot"><span class="i5glb-count"></span></div></div>';
document.body.appendChild(lb);
var im=lb.querySelector('.i5glb-img'),tb=lb.querySelector('.i5glb-thumbs'),cnt=lb.querySelector('.i5glb-count'),tName=lb.querySelector('.i5glb-t b'),tSub=lb.querySelector('.i5glb-t span'),metaD=lb.querySelector('.i5glb-meta-d'),metaM=lb.querySelector('.i5glb-meta-m'),stage=lb.querySelector('.i5glb-stage');
var cur=null,idx=0;
var pointers={},sd=0,ss=1,scale=1,tx=0,ty=0,psx=0,psy=0,panning=false,downX=0,downY=0;
function applyT(){im.style.transform='translate('+tx+'px,'+ty+'px) scale('+scale+')';}
function resetZoom(){scale=1;tx=0;ty=0;panning=false;pointers={};sd=0;lb.classList.remove('zoom');im.style.transform='';}
function preload(i){if(cur&&i>=0&&i<cur.i.length){var x=new Image();x.src=url(cur.i[i],1400);}}
function metaHTML(p){
  var w=p.c?'<a class="i5glb-ig" href="'+esc(p.c)+'" target="_blank" rel="noopener">'+IG+'Watch highlights</a>':'';
  var av=p.a?'<img class="i5glb-av" src="'+url(p.a,140)+'" alt="">':'';
  var bu=BOOK+(BOOK.indexOf('?')>-1?'&':'?')+'designer='+encodeURIComponent(first(p.d));
  var book='<a class="i5glb-book" data-bookwith="'+esc(first(p.d))+'" href="'+esc(bu)+'">'+esc(BKL+' '+first(p.d))+'</a>';
  return w+'<div class="i5glb-drow"><div class="i5glb-dz">'+av+'<b>'+esc(DZL+' '+p.d)+'</b></div>'+book+'</div>';
}
function render(){
  resetZoom();
  im.src=url(cur.i[idx],1400);im.alt=cur.l+' — photo '+(idx+1);
  cnt.textContent=(idx+1)+' / '+cur.i.length;
  preload(idx+1);preload(idx-1);
  [].forEach.call(tb.children,function(t,i){var on=i===idx;t.classList.toggle('on',on);if(on)t.scrollIntoView({block:'nearest',inline:'center'});});
}
function openLB(p,start){
  cur=p;idx=start||0;tName.textContent=p.l;tSub.textContent=p.s;
  var m=metaHTML(p);metaD.innerHTML=m;metaM.innerHTML=m;
  tb.innerHTML='';
  p.i.forEach(function(n,i){var t=document.createElement('img');t.src=url(n,180);t.loading='lazy';t.alt='';t.addEventListener('click',function(){idx=i;render();});tb.appendChild(t);});
  render();lb.classList.add('on');document.documentElement.style.overflow='hidden';
}
function close(){lb.classList.remove('on');document.documentElement.style.overflow='';resetZoom();}
function go(d){idx=(idx+d+cur.i.length)%cur.i.length;render();}
window.i5OpenLB=openLB;
lb.querySelector('.i5glb-x').onclick=close;
lb.querySelector('.i5glb-prev').onclick=function(e){e.stopPropagation();go(-1);};
lb.querySelector('.i5glb-next').onclick=function(e){e.stopPropagation();go(1);};
document.addEventListener('keydown',function(e){if(!lb.classList.contains('on'))return;if(e.key==='Escape')close();else if(e.key==='ArrowLeft')go(-1);else if(e.key==='ArrowRight')go(1);});
function twoDist(){var k=Object.keys(pointers);var a=pointers[k[0]],b=pointers[k[1]];return Math.hypot(a.x-b.x,a.y-b.y);}
stage.addEventListener('pointerdown',function(e){
  if(e.target!==im&&e.target!==stage)return;
  pointers[e.pointerId]={x:e.clientX,y:e.clientY};
  var ids=Object.keys(pointers);
  if(ids.length===2){sd=twoDist();ss=scale;panning=false;}
  else if(ids.length===1){downX=e.clientX;downY=e.clientY;if(scale>1){panning=true;psx=e.clientX-tx;psy=e.clientY-ty;}}
  try{stage.setPointerCapture(e.pointerId);}catch(x){}
});
stage.addEventListener('pointermove',function(e){
  if(!pointers[e.pointerId])return;
  pointers[e.pointerId]={x:e.clientX,y:e.clientY};
  var ids=Object.keys(pointers);
  if(ids.length===2){var d=twoDist();if(sd){scale=Math.min(4,Math.max(1,ss*d/sd));lb.classList.toggle('zoom',scale>1.02);applyT();}}
  else if(panning){tx=e.clientX-psx;ty=e.clientY-psy;applyT();}
});
function ptUp(e){
  var wasSingle=Object.keys(pointers).length===1;
  var dx=e.clientX-downX,dy=e.clientY-downY;
  delete pointers[e.pointerId];
  var left=Object.keys(pointers).length;
  if(left<2)sd=0;
  if(left===0){
    if(scale<=1.02){if(wasSingle&&Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){go(dx<0?1:-1);}resetZoom();}
    else{panning=false;}
  }
}
stage.addEventListener('pointerup',ptUp);
stage.addEventListener('pointercancel',function(e){delete pointers[e.pointerId];if(Object.keys(pointers).length<2)sd=0;});
stage.addEventListener('click',function(e){if(e.target===stage&&scale<=1.02)close();});
stage.addEventListener('wheel',function(e){e.preventDefault();scale=Math.min(4,Math.max(1,scale-e.deltaY*0.0025));lb.classList.toggle('zoom',scale>1.02);if(scale<=1.02){tx=0;ty=0;}applyT();},{passive:false});
document.querySelectorAll('.i5g').forEach(function(g){
  var track=g.querySelector('.i5g-track');if(!track||track.children.length)return;
  projs.forEach(function(p,i){
    var cover=url(p.i[0],800),avu=url(p.a,140);
    var card=document.createElement('button');card.className='i5g-card';card.setAttribute('data-p',i);card.setAttribute('aria-label',p.l+' — open gallery');
    var hl=p.c?'<a class="i5g-hl" href="'+esc(p.c)+'" target="_blank" rel="noopener">'+IG+'Watch highlights</a>':'';
    card.innerHTML='<div class="i5g-card-img"><img loading="lazy" src="'+cover+'" alt="'+esc(p.l)+' — interior design by ebarza, '+esc(p.s)+'"><div class="i5g-card-grad"></div></div>'+
      '<div class="i5g-ttl"><b>'+esc(p.l)+'</b><span>'+esc(p.s)+'</span></div>'+
      '<div class="i5g-cnt">'+p.i.length+' photos</div>'+
      '<div class="i5g-foot">'+(avu?'<img class="i5g-av" src="'+avu+'" alt="'+esc(p.d)+'">':'')+'<div class="i5g-des">Designer: <b>'+esc(p.d)+'</b></div>'+hl+'</div>';
    track.appendChild(card);
  });
  var prev=g.querySelector('.i5g-prev'),next=g.querySelector('.i5g-next');
  function step(){var c=track.querySelector('.i5g-card');return c?c.getBoundingClientRect().width+20:320;}
  if(prev)prev.onclick=function(){track.scrollBy({left:-step(),behavior:'smooth'});};
  if(next)next.onclick=function(){track.scrollBy({left:step(),behavior:'smooth'});};
});
document.addEventListener('click',function(e){
  if(e.target.closest('.i5g-hl'))return;
  var c=e.target.closest('.i5g-card');
  if(c){e.preventDefault();openLB(projs[+c.getAttribute('data-p')],0);}
});
/* Book button in the lightbox: when a booking form exists on THIS page, close the
   lightbox and drive it in place (icBookWith selects the designer and scrolls);
   only pages without a form follow the href. Runs in capture phase so it wins
   over the shared [data-bookwith] handler, which cannot close the lightbox. */
document.addEventListener('click',function(e){
  var a=e.target.closest('.i5glb-book');if(!a)return;
  var w=document.querySelector('[class*="tpb__widget"],.tpb-booking-form');
  if(w&&window.icBookWith){
    e.preventDefault();e.stopPropagation();
    close();
    window.icBookWith(a.getAttribute('data-bookwith'));
  }
},true);
})();
